// @ts-nocheck

/*
  A collection of helper functions to configure the intitial global objects for each respective service.
  TS ignored due to ambiguous types as none of these services utilize TS.
*/

/*
  Provided by Pendo: https://support.pendo.io/hc/en-us/articles/360031862272-Installation-for-Single-Page-Frameworks
*/ 
export const attachPendo = (apiKey) => {
  (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
    v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
    o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
    y=e.createElement(n);y.async=!0;y.src=`https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
    z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
};
